import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #666666;
`

const RemoveCircle = ({ title = 'Remove', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 18 18" title={title} {...rest}>
    <g fill="none" fillRule="evenodd">
      <circle fill="currentColor" cx={9} cy={9} r={9} />
      <path
        d="M12.316 5.684l-6.632 6.632M12.316 12.316L5.684 5.684"
        stroke="#FFF"
        strokeWidth={2}
        strokeLinecap="square"
      />
    </g>
  </StyledIcon>
)

RemoveCircle.displayName = 'RemoveCircle'
RemoveCircle.needsWork = true
export default RemoveCircle
